
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wave-3-portable-air-conditioner/specs",
      function () {
        return require("private-next-pages/wave-3-portable-air-conditioner/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wave-3-portable-air-conditioner/specs"])
      });
    }
  